var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-registry-list.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\n<div class=\"dom-registry-list\">\n\n";
if(runtime.contextOrFrameLookup(context, frame, "registry") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"showProductRegistries") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "registry")),"registries") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "registry")),"meta")),"count") > 0) {
output += "\n\n    <ul class=\"u-no-gutters c-form__select-styled o-column o-extra-small--12\">\n\n        ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "registry")),"registries");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("registry", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n            <li class=\"c-form__select-styled__li\">\n\n                <a href=\"#\" class=\"c-form__select-styled__a js-add-to-registry\" id=\"registry-list-name\" data-registry-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" data-registry-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"event")),"name"), env.opts.autoescape);
output += "\" data-qa-registry-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"event")),"name"), env.opts.autoescape);
output += "\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"event")),"name"), env.opts.autoescape);
output += "\n                </a>\n\n            </li>\n\n        ";
;
}
}
frame = frame.pop();
output += "\n\n    </ul>\n\n";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-registry-list.j2"] , dependencies)